import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { ThemeProvider, createTheme } from "@mui/material/styles";

// 🌍 Contextes globaux
import { GroupeProvider } from "./context/GroupeContext.js";
import { MenuProvider } from "./context/MenuContext.js";

// 🧭 Router pour activer la navigation
import { BrowserRouter } from "react-router-dom";

// 🔑 Création du "root" React : c’est ici que ton app est injectée dans le DOM
const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme(); 

// 🚀 Rendu de l’application
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ThemeProvider theme={theme}>
      <GroupeProvider>
        <MenuProvider>
          <App />
        </MenuProvider>
      </GroupeProvider>
      </ThemeProvider>
      </BrowserRouter>
  </React.StrictMode>
);

// 📈 Mesure des performances (optionnel, peut être relié à un service d’analytics)
reportWebVitals();
